import NewsletterSubscribe from '../../../article/components/NewsletterSubscribe/NewsletterSubscribe';
import { Match, MatchFilterConfig, Club, TenantFeatureFlags } from '@repo/types';
import FixtureListUI from '../FixtureList/FixtureListUI';
import { ClubNameType } from '../../contracts';
import { MonthSwitcher, MonthSwitcherProps } from './components/MonthSwitcher';
import { CompetitionSwitcher } from './components/CompetitionSwitcher';
import { ClubSwitcher } from './components/ClubSwitcher';
import { SocialNetworks } from '../../../league/components/SocialNetworks/SocialNetworks';
import { CompetitionSwitcherMobile } from './components/CompetitionSwitcherMobile';
import { MonthData } from '../../../utils/date';
import { SponsorsGrid } from '../../../league/components/SponsorsGrid';
import { DateSwitcher } from './components/DateSwitcher';

type MatchesListPageProps = {
  title?: string;
  isMobile: boolean;
  matchFilters?: MatchFilterConfig[];
  selectedCompetition?: MatchFilterConfig;
  matches: Match[];
  clubs?: Club[];
  currentMonth?: MonthData;
  monthSwitcherMode?: MonthSwitcherProps['mode'];
  featureFlags?: TenantFeatureFlags;
  sortByDate?: 'ASC' | 'DESC';
  matchDates?: string[];
};

export function MatchesListPage({
  title,
  isMobile,
  matchFilters,
  selectedCompetition,
  matches,
  clubs,
  currentMonth,
  monthSwitcherMode,
  featureFlags,
  sortByDate = 'ASC',
  matchDates,
}: MatchesListPageProps) {
  return (
    <div className="matches-list">
      <div className="matches-list__left-side">
        <div className="matches-list__content">
          {title && (
            <div className="matches-list__title-container">
              {/* <h1 className="matches-list__title">{title}</h1> */}
              {!isMobile && featureFlags && clubs && featureFlags.filterMatchesByClub && <ClubSwitcher clubs={clubs} />}
            </div>
          )}

          {featureFlags && clubs && matchFilters && (
            <div className="matches-list__filters-container">
              {isMobile && (
                <CompetitionSwitcherMobile
                  isMobile={isMobile}
                  matchFilters={matchFilters}
                  selectedCompetition={selectedCompetition}
                />
              )}
              {!isMobile && (
                <CompetitionSwitcher
                  isMobile={isMobile}
                  matchFilters={matchFilters}
                  selectedCompetition={selectedCompetition}
                />
              )}
              {isMobile && featureFlags?.filterMatchesByClub && clubs && <ClubSwitcher clubs={clubs} />}
            </div>
          )}
          <div className="matches-list__date-filters-container">
            {monthSwitcherMode && <MonthSwitcher initialMonth={currentMonth} mode={monthSwitcherMode} />}
            {monthSwitcherMode && (
              <div className="matches-list__date-picker-container">
                <DateSwitcher matchDates={matchDates} />
              </div>
            )}
          </div>
          <FixtureListUI
            className="matches-list__matches-container"
            fixtures={matches}
            columns={1}
            groupByDate
            showAttendance={!isMobile}
            groupByCompetition
            nameType={ClubNameType.FullName}
            competitionsSort={selectedCompetition?.competitions.split(',')}
            isFixtureExpandable={!isMobile}
            sortByDate={sortByDate}
          />
          <div className="matches-list__newsletter-container">
            <NewsletterSubscribe title={'Get the latest news straight to your inbox'} />
          </div>
          <h3 className={'matches-list__social-networks-title'}>
            {/* @ts-ignore TODO: fix this */}
            Follow {import.meta.env.VITE_ENTITY_NAME} on Social:
          </h3>
          <SocialNetworks className="matches-list__social-networks" />
          <SponsorsGrid
            className="matches-list__sponsors-grid"
            title="Our Trusted Partners"
            showAllSponsors
            showImage
            columns={isMobile ? 3 : 5}
            showName={false}
            showDescription={false}
          />
        </div>
      </div>
    </div>
  );
}
